/* RESPONSIBLE TEAM: team-actions */
import { buildValidations, validator } from 'ember-cp-validations';

function validateDomainHost(value: string | null | undefined): boolean {
  if (value === null || value === undefined) {
    return true;
  }

  if (value === '') {
    return false;
  }

  if (value.length > 255) {
    return false;
  }

  let domainRegex = /^[a-z0-9]+([-.]?[a-z0-9]+)*\.[a-z]{2,}$/i;
  if (!domainRegex.test(value)) {
    return false;
  }

  return true;
}

export default buildValidations({
  name: {
    validators: [validator('presence', { presence: true })],
  },
  tokenValue: {
    validators: [validator('presence', { presence: true })],
  },
  requestHeaderKey: {
    validators: [validator('presence', { presence: true })],
  },
  domain: {
    validators: [
      validator('inline', {
        validate: validateDomainHost,
      }),
    ],
  },
});
